<template>
    <div ref="dropdown" class="dropdownMenu" :class="{ open: isOpen, dropup: isDropup, dropleft: isDropleft  }"
        style="position: relative; display: inline-block">
        <button @click="toggleDropdown" :class="buttonClass">
            <slot name="button">⋮</slot>
        </button>
        <div v-show="isOpen" ref="menu" class="dropdown_menu" style="position: absolute; z-index: 10">
            <slot name="menu" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        buttonClass: {
            type: [String, Array],
            default: ''
        }
    },
    data() {
        return {
            isOpen: false,
            isDropup: false,
            isDropleft: false,
        };
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
            this.$nextTick(() => {
                const dropdown = this.$refs.dropdown;
                const menu = this.$refs.menu;
                const rect = dropdown.getBoundingClientRect();
                const menuHeight = menu.offsetHeight;
                const menuWidth = menu.offsetWidth;
                const spaceBelow = window.innerHeight - rect.bottom;
                const spaceRight = window.innerWidth - rect.left;
                this.isDropup = spaceBelow < menuHeight;
                this.isDropleft = spaceRight < menuWidth;
            });
        },
        handleClickOutside(e) {
            if (!this.$el.contains(e.target)) {
                this.closeDropdown();
            }
        },
        closeDropdown() {
            this.isOpen = false;
        }
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
};
</script>
<style scoped>
.dropdownMenu {width: 100%; display: inline-block;}
.dropdownMenu > button.base {
    font-size: 14px;
    background-color: white;
    border: 1px solid #ccc;
    padding: 6px 10px 6px 10px;
    border-radius: 4px;
    display: inline-block;
    color: black;
    text-decoration: none;
    cursor: pointer;
    text-align: center;
}
.dropdownMenu > button.arrow-down {padding: 6px 20px 6px 10px!important}
.dropdownMenu > button.arrow-down:before {
    position: absolute;
    right: 7px;
    top: 10px;
    content: ' ';
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid black;
}
.dropdown_menu {
    border: 1px solid #ccc;
    padding: 4px 0px;
    background-color: white;
    box-shadow: 0 3px 6px rgba(0,0,0,.175);
    min-width: 100px;
    padding: 0.5rem 0;
    top: 100%;
    left: 0;
    text-align: left;
}

.dropdown_menu ul li {
    display: block;
    padding: 3px 10px;
    white-space: nowrap;
    min-width: 100px;
}

.dropdown_menu ul li, .dropdown_menu ul li a, .dropdown_menu ul li button {
    text-decoration: none;
    display: block;
    color: black;
    font-size: 12px;
    border: 0;
    background-color: transparent;
    box-shadow: none;
}
.dropdown_menu ul li:hover {
    background-color: #F5F5F5;
}
.dropdown_menu ul li:hover, .dropdown_menu ul li a:hover, .dropdown_menu ul li button:hover {
    cursor: pointer;
}
.dropup .dropdown_menu {
    top: auto;
    bottom: 100%;
}
.dropleft .dropdown_menu {
    left: auto;
    right: 0;
}
.open .dropdown_menu {
    display: block;
}
</style>
